<template>
  <div class="player-container">
    <video-player
	v-if="this.videoSrc"
		v-loading="!videoSrc"
      class="vjs-custom-skin"
      :options="playerOptions"
    ></video-player>
  </div>
</template>
<script>
//引入video样式
import "video.js/dist/video-js.css";
import "vue-video-player/src/custom-theme.css";
//引入hls.js
// import "videojs-contrib-hls/src/videojs-contrib-hls.js";

export default {
  props: {
      videoSrc:String,
      posterSrc:String,
  },
  data() {
    return {
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        controls: true, //控制条
        preload: "auto", //视频预加载
        muted: false, //默认情况下将会消除任何音频。
        loop: false, //导致视频一结束就重新开始。
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "video/mp4",
            src: "", //你所放置的视频的地址，最好是放在服务器上
          },
        ],
        poster: "", //你的封面地址（覆盖在视频上面的图片）
        width: document.documentElement.clientWidth,
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true, // 全屏按钮
        },
      },
    };
  },
  watch:{
	  'videoSrc':{
		  handler(newVal, oldVal) {
		  	if(newVal){
		  		this.playerOptions.sources[0].src = newVal;
		  	}
		  	
		  },
	  },
	  "posterSrc":{
		  handler(newVal, oldVal) {
		  	if(newVal){
		  		this.playerOptions.sources[0].poster = newVal;
		  	}
		  	
		  },
	  }
  },
  mounted(){
      this.playerOptions.sources[0].src = this.videoSrc;
      this.playerOptions.sources[0].poster = this.posterSrc;
  }
};
</script>
<style type="text/css">
	.vjs-volume-panel{
		display: none !important;
	}
	.vjs-custom-skin > .video-js .vjs-big-play-button {
	    background-color: rgba(0,0,0);
	    font-size: 3em;
	    border-radius: 50%;
	    width: 1.5em;
	    height: 1.5em !important;
	    line-height: 1.5em !important;
	    margin-top: -.7em !important;
	}
	.vjs-custom-skin > .video-js .vjs-big-play-button {
	    top: 50%;
	    left: 50%;
	    margin-left: -.7em;
	    margin-top: -1em;
	}
	.video-js button{
		border: 0 !important;
	}
</style>